module.exports = __webpack_public_path__ + "static/fonts/CeraPro-Regular.6974176.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CeraPro-Regular.woff2
// module id = vGzK
// module chunks = 1